/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ConfigurationIcon extends BaseIcon {
  getChildren = () => [
    <g fill={ this.getColor() }>
      <circle cx="5" cy="3" r="2"/>
      <path d="M2,3a3,3,0,0,1,.18-1H0V4H2.18A3,3,0,0,1,2,3Z"/>
      <path d="M7.82,2A3,3,0,0,1,8,3a3,3,0,0,1-.18,1H16V2Z"/>
      <circle cx="11" cy="8" r="2"/>
      <path d="M14,8a3,3,0,0,0-.18-1H16V9H13.82A3,3,0,0,0,14,8Z"/>
      <path d="M8.18,7a2.87,2.87,0,0,0,0,2H0V7Z"/>
      <circle cx="5" cy="13" r="2"/>
      <path d="M2,13a3,3,0,0,1,.18-1H0v2H2.18A3,3,0,0,1,2,13Z"/>
      <path d="M7.82,12a2.87,2.87,0,0,1,0,2H16V12Z"/>
    </g>
  ]
  getViewBox = () => '0 0 16 16'
}
